import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataColacaoGrau = (): TabelaColuna => ({
  Chave: 'dataColacaoGrau',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataColacaoGrau)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Col. Grau</div>
})
